export default __webpack_public_path__ + "static/media/GrowingIvy1.2329f4d0.png";